import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/diagnostic-image-result";

// Lưu ảnh chung của kết quả điều trị
export const saveDiagnosticReportImages = (dto) =>
  axios.post(API_PATH + "/save-diagnostic-report-images", dto);

// Lấy ảnh của kết quả điều trị và ảnh của các bước trong kết quả
export const getDiagnosticReportWithImages = (diagnosticReportId) =>
  axios.get(API_PATH + "/diagnostic-report-with-images/" + diagnosticReportId);

// Lưu ảnh của từng bước trong kết quả điều trị
export const saveDiagnosticResultImages = (dto) =>
  axios.post(API_PATH + "/save-diagnostic-result-images", dto);

// Lấy ảnh của các bước trong kết quả điều trị
export const getDiagnosticResultWithImages = (diagnosticResultId) =>
  axios.get(API_PATH + "/diagnostic-result-with-images/" + diagnosticResultId);

// Lấy ra hình ảnh điều trị của 3 lần gần nhất (3 diag có ảnh điều trị)
export const getLatestResultImagesIn3DiagnosticReportsByPatientId = (patientId) =>
  axios.get(API_PATH + "/latest-result-images-in-3-diagnostic-reports/" + patientId);
